<template>
  <q-intersection>
    <slot />
    <template
      v-if="$slots.hidden"
      #hidden
    >
      <slot name="hidden" />
    </template>
  </q-intersection>
</template>
